import { Audit } from '@bdfx/audit-api/types'
import { useContext } from 'react'
import { AuditContext } from '../providers/AuditProvider'
import { css, theme } from '@bdfx/fukit'
import ctrans from "../../common/trans"
import logotypeBF from '../../resources/logotype-bf.svg'
import logotypeMergadoAudit from '../../resources/MERGADO_Audit_na_sirku.svg'
import logotypeImageAudit from '../../resources/image_audit_logo.png'
import { plausible } from '../../common/tracking'

const auditTargets = {
    "biddingAudit" : {
        title: "Bidding Audit",
        name: "bidding",
        base_href: "https://bidding-audit.cz/",
        image_url: logotypeBF,
        utmTagsString: "utm_source=audit_pricing&utm_medium=app&utm_campaign=pricing_audit",
    },
    "imageAudit" : {
        title: "Image Audit",
        name: "image",
        base_href: "https://audit-obrazku.cz/",
        image_url: logotypeImageAudit,
        utmTagsString: "utm_source=audit_pricing&utm_medium=app&utm_campaign=pricing_audit",
    },
    "mergadoAudit" : {
        title: "Feed Audit by Mergado",
        name: "mergado",
        base_href: "https://audit.mergado.com/",
        image_url: logotypeMergadoAudit,
        utmTagsString: "",
    },
} as const

type AuditTargetTypes = keyof typeof auditTargets


// ```
// https://pricing-audit.cz/?conversion=https://www.heureka.cz/direct/xml-export/shops/roi/3EDC0CA137C1C16EC95477B434401F42/nuspring-cz_day.xml.gz&feed=https://nuspring.cz/exports/variant_masterfeed.xml&email=norbert.gasparik@biddingfox.com
// ```
export default function AuditsLinks() {

    const [data]: [Audit] = useContext(AuditContext)

    const { notify_email, source_feed_url, source_heureka_conversion_url } = data

    const getTargetUrl = (type: AuditTargetTypes) => {

        const target = auditTargets[type]

        if(type === "mergadoAudit") {
            return target.base_href
        }

        if(type === "imageAudit") {

            const params = new URLSearchParams();

            source_feed_url && params.append("feedurl", source_feed_url)
            const paramsString = params.toString();
            
            const finalHref = `${target.base_href}${paramsString ? `?${paramsString}&` : "?"}${target.utmTagsString}`
            
            return finalHref
        }
        if (type === "biddingAudit") {
            
            const params = new URLSearchParams();
            
            source_heureka_conversion_url && params.append("conversion", source_heureka_conversion_url) 
            source_feed_url && params.append("feed", source_feed_url)
            notify_email && params.append("email", notify_email)  
            
            const paramsString = params.toString();
            
            const finalHref = `${target.base_href}${paramsString ? `?${paramsString}&` : "?"}${target.utmTagsString}`
            
            return finalHref
        }
        return target.base_href
    }

    const handleClick = (target: string) => (e) => {
        const plausibleKey = "pf_audit_link_" + target;
        console.log("handleClick", target, "plausibleKey",plausibleKey);
        plausible(plausibleKey, { props: { id: data?.id, email: data?.notify_email } })
        
    }
    
    return (
        <section className="other-audits">
            <p style={{textAlign: "center"}}>
                {ctrans("other_audits_links_label")}:
            </p>

            <Wrapper>
                {Object.keys(auditTargets).map((target) => (
                    <Anchor key={target} onClick={handleClick(target)} href={getTargetUrl(target as AuditTargetTypes)} title={auditTargets[target].title} target="_blank">
                        <img src={auditTargets[target].image_url} alt={auditTargets[target].title} height="60" width="150" />
                    </Anchor>
                ))}
            </Wrapper>

        </section>
    )
}


const Wrapper = css("div")({
    display: "flex",
    gap: "0.5em 1em",
    justifyContent: "center",
    aliggnItems: "center",
    flexWrap: "wrap",
})

const Anchor = css("a")({
    display: "inline-block",
    borderRadius: "999em",
    background: "white",
    boxShadow: "2px 2px 8px 0 rgb(0 0 0 / 30%)",
    padding: "1em",
    border: "1px solid " + theme.green,
    transition: "all 0.1s",
    ":hover": {
        boxShadow: "0 0 2px 0 rgb(0 0 0 / 30%)",
        transform: "translate3d(1px,1px,0)",
    }
})